import { render, staticRenderFns } from "./PublicStocks.vue?vue&type=template&id=1900dc96&scoped=true"
import script from "./PublicStocks.vue?vue&type=script&lang=js"
export * from "./PublicStocks.vue?vue&type=script&lang=js"
import style0 from "./PublicStocks.vue?vue&type=style&index=0&id=1900dc96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1900dc96",
  null
  
)

export default component.exports